<!-- <div class="bg-gray-100 font-sans antialiased min-h-screen pb-12">
    <div class="flex flex-col lg:flex-row">
        <div class="flex items-center justify-center mt-5 lg:ml-10 mb-6">
            <img alt="Logo" class="h-24 w-48 lg:h-24 lg:w-60" src="assets/companyLogo.png" />
        </div>
        <div class="flex flex-col lg:flex-row justify-between items-center mb-6 w-full lg:w-full px-4 lg:px-0"> -->
            <!-- Add menu toggle button for desktop -->
            <!-- <div class="lg:ml-80"></div>
            <div class="flex items-center lg:ml-96 lg:mr-8 space-x-8 lg:space-x-10 sm:mt-4 lg:mt-0">
                <i class="fas fa-bell text-purple-700 relative">
                    <span class="absolute top-0 right-0 inline-block w-2 h-2 bg-red-600 rounded-full"></span>
                </i>
                <i class="fas fa-envelope text-gray-400"></i>
                <i class="fas fa-user text-gray-400" ></i>
                <i class="fas fa-sign-out-alt text-gray-400 text-xl cursor-pointer" (click)="onLogoutClick()"></i>
                <i class="fas fa-bars text-purple-700 text-xl font-bold cursor-pointer " (click)="toggleMenu()">
                </i>
            </div>
        </div>
      </div> -->

    <!-- <div class="flex flex-col lg:flex-row"> -->
        <!-- Sidebar -->
        <!-- <div class="w-full lg:w-80 bg-gray-200 lg:ml-10 shadow-lg p-6" [class.hidden]="!menuOpen">
            <nav class="mt-4 lg:mt-10">
                <a class="flex items-center py-3 px-6 border rounded-lg bg-white text-gray-400 hover:shadow-lg cursor-pointer" (click)="onHomeClick()">
                    <i class="fas fa-home text-purple-600"></i>
                    <span class="mx-4 font-medium">Home</span>
                    <i class="fas fa-caret-down ml-auto"></i>
                </a>
                <a class="flex items-center py-3 mt-4 px-6 border rounded-lg bg-white text-gray-400 hover:shadow-lg cursor-pointer" (click)="onreportClick()">
                    <i class="fas fa-clipboard-list text-purple-600"></i>
                    <span class="mx-4 font-medium">Reports</span>
                    <i class="fas fa-caret-down ml-auto"></i>        
                </a>
                <a class="flex items-center py-3 mt-4 px-6 border rounded-lg bg-white text-gray-400 hover:shadow-lg cursor-pointer" (click)="onDeviceDetailClick()">
                    <i class="fas fa-calendar-alt text-purple-600"></i>
                    <span class="mx-4 font-medium">Device</span>
                    <i class="fas fa-caret-down ml-auto"></i>
                </a>
                <a class="flex items-center py-3 px-6 mt-10 lg:mt-56 text-white bg-purple-600 rounded-lg hover:bg-purple-700" href="https://penguinhealth.ca/">
                    <i class="fas fa-external-link-alt mx-8"></i>
                    <span class="mx-0 font-medium text-center">Visit More</span>
                </a>
            </nav>
        </div> -->

        <!-- Main Content -->
        <!-- <div class="flex-1 pt-4 pr-10 pl-10 lg:w-1/2">
            <div class="flex flex-col lg:flex-row mb-4 ml-5 gap-4">
                <div class="flex flex-col lg:flex-row gap-4">
                    <div class="flex">
                        <label class="lg:mt-2">Start Time</label>
                        <div class="relative ml-4 ">
                            <input class="p-2 fields" 
                                   type="date" 
                                   [(ngModel)]="startTime"
                                   (change)="onDateChange()"/>
                        </div>
                    </div>
                    <div class="flex   lg:ml-8">
                        <label class="lg:mt-2">End Time</label>
                        <div class="relative ml-4">
                            <input class="p-2 fields" 
                                   type="date" 
                                   [(ngModel)]="endTime"
                                   (change)="onDateChange()"/>
                        </div>
                    </div>
                </div>
                <div class="flex gap-4 lg:ml-40">
                    <button class="flex items-center  px-4 text-white bg-gray-500 rounded-lg hover:bg-purple-700"
                            (click)="exportExcel()">
                        <span class="mx-1 font-medium">Excel</span>
                    </button>
                    <button class="flex items-center py-1 px-8 text-white bg-purple-500 rounded-lg hover:bg-purple-700"
                            (click)="exportPDF()">
                        <span class="mx-1 font-medium">PDF</span>
                    </button>
                </div>
            </div>

            <div class="bg-white p-6 rounded-lg shadow-lg">
                <div class="flex flex-col lg:flex-row justify-between items-center mb-6">
                    <h2 class="text-xl font-semibold mb-4 lg:mb-0">Reports</h2> -->


                    <!-- <div class="flex flex-col lg:flex-row gap-4 w-full lg:w-auto">
                        <div class="relative w-full lg:w-64">
                            <input type="text" 
                                   [(ngModel)]="searchText"
                                   (input)="applySearchAndFilter()"
                                   placeholder="Search" 
                                   class="w-full ml-1 p-2 pl-10 border text-center rounded-lg"/>
                        </div>
                        
                    </div> -->
                <!-- </div>
                
                <div class="overflow-x-auto">
                    <table class="min-w-full bg-white"> -->
                        <!-- Table content from your original code -->
                        <!-- <thead class="text-center">
                            <tr>
                                <th class="py-1 px-1 columnheading border-b border-gray-200">Record</th>
                                <th class="py-1 px-4 columnheading border-b border-gray-200">Start Time</th>
                                <th class="py-1 px-4 columnheading border-b border-gray-200">End Time</th> -->
                                <!-- <th class="py-1 px-3 columnheading border-b border-gray-200">Clinic Name</th> -->
                                <!-- <th class="py-1 px-3 columnheading border-b border-gray-200">Clinic Address</th> -->
                                <!-- <th class="py-2 px-3 columnheading border-b border-gray-200">Well</th>
                                <th class="py-2 px-3 columnheading border-b border-gray-200">Serial</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">Result</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">BI Type</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">BI Lot Number</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">Sterilizer Model</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">Load Number</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">Team Member</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">Cycle</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">Chemical Integrator</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">Control</th>
                                <th class="py-1 px-3 columnheading border-b border-gray-200">Implant</th>
                            </tr> -->
                        <!-- </thead>
                        <tbody>
                            <tr *ngFor="let record of filteredRecords.length > 0 ? filteredRecords : records; let i = index" class="text-center">
                                <td class="py-2 text-sm px-1 border-b border-gray-200">{{ i+1 }}</td>
                                <td class="py-2 px-4 text-xs border-b border-gray-200">{{ record.startTime | date:'dd-MM-yy HH:mm' }}</td>
                                <td class="py-2 px-4 text-xs border-b border-gray-200">{{ record.endTime | date:'dd-MM-yy HH:mm:ss' }}</td> -->
                                <!-- <td class="py-2 px-2 border-b border-gray-200">{{ record.clinicName }}</td> -->
                                <!-- <td class="py-2 px-2 border-b border-gray-200">{{ record.clinicAddress }}</td> -->
                                <!-- <td class="py-2 px-1 border-b border-gray-200">{{ record.wellNumber }}</td>
                                <td class="py-2 px-1 border-b border-gray-200">{{ record.serialNumber }}</td>
                                <td class="py-2 px-1 border-b border-gray-200">{{ record.result }}</td>
                                <td class="py-2 px-1 border-b border-gray-200">{{ record.biType }}</td>
                                <td class="py-2 px-1 border-b border-gray-200">{{ record.biLotNumber }} </td>
                                <td class="py-2 px-1 border-b border-gray-200">{{ record.sterilizerModels }} </td>
                                <td class="py-2 px-1 border-b border-gray-200">{{ record.loadNumber }} </td>
                                <td class="py-2 px-1 border-b border-gray-200">{{ record.technicianNames }} </td>
                                <td class="py-2 px-1 border-b border-gray-200">{{ record.cycleCount }} </td>
                                <td class="py-2 px-1 border-b border-gray-200">{{ record.chemicalIntegrators }} </td>
                                <td class="py-2 px-1 border-b border-gray-200">
                                    <button class="text-purple-600 controldiv px-4 py-1"
                                            [disabled]="!record.isControlTest"
                                            [ngClass]="{'opacity-50 cursor-not-allowed': !record.isControlTest}">
                                        Control
                                    </button>
                                </td>
                                <td class="py-2 px-1 border-b border-gray-200">
                                    <button class="text-purple-600 controldiv px-4 py-1"
                                            [disabled]="!record.isImplant"
                                            [ngClass]="{'opacity-50 cursor-not-allowed': !record.isImplant}">
                                        Implant
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="flex flex-col lg:flex-row justify-between items-center mt-4">
                    <span class="mb-4 lg:mb-0">Page {{ currentPage + 1 }} of {{ totalPages }}</span>
                    <div class="flex gap-2">
                        <button class="px-4 py-2 bg-purple-600 text-white rounded disabled:opacity-50"
                                (click)="changePage(currentPage - 1)" 
                                [disabled]="currentPage === 0">
                            Previous
                        </button>
                        <button class="px-4 py-2 bg-purple-600 text-white rounded disabled:opacity-50"
                                (click)="changePage(currentPage + 1)" 
                                [disabled]="currentPage === totalPages || totalPages == currentPage + 1">
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-notification-popup
        [isOpen]="showPopup"
        [message]="popupMessage"
        [type]="popupType"
        (onClose)="closePopup()">
    </app-notification-popup>
</div> -->


<div class="maincontainer font-sans gap-8">
     <!-- Transparent overlay layer - shown only when settings popup is open -->
     <div *ngIf="showSettings" class="fixed inset-0 bg-opacity-30 z-10" (click)="closeSettings()"></div>
    
     <div class="flex flex-col md:flex-row h-screen">
         <!-- Mobile Header with Menu Toggle -->
         <div class="block md:hidden bg-white p-4 shadow-sm">
             <div class="flex items-center justify-between">
                 <img alt="Atlas Track Logo" class="h-8" src="assets/newui/atlasnewlogo.png"/>
                 <button class="text-gray-600" (click)="toggleMenu()">
                     <i class="fas fa-bars text-xl"></i>
                 </button>
             </div>
         </div>
 
         <!-- Sidebar - Hidden on mobile by default, shown when toggled -->
         <div class="w-full md:w-80 bg-white p-4   sidebar-menu" [ngClass]="{'hidden': !menuOpen, 'block': menuOpen, 'md:block': true}">
            <div class="flex items-center justify-center h-12 md:h-16 mb-6">
                <img alt="Atlas Track Logo" class="max-w-full h-auto" src="assets/newui/atlasnewlogo.png" width="180"/>
            </div>
            <div class="mt-4 md:mt-10">
                <a class="flex items-center py-2 px-4 md:px-8 hover:bg-purple-50 hover:rounded-lg text-gray-900 hover:text-purple-700 cursor-pointer" (click)="onHomeClick()">
                    <i class="fas fa-th-large mr-3"></i>
                    <span>Home</span>
                </a>
                
                <!-- Reports Dropdown Menu -->
                <div class="relative">
                    <!-- Reports Menu Header -->
                    <a class="flex items-center py-2 px-4 md:px-8 text-gray-600 mt-3 hover:bg-purple-50 hover:rounded-lg hover:text-purple-700 cursor-pointer" (click)="toggleReportsDropdown()">
                        <i class="fas fa-file-alt mr-3"></i>
                        <span>Download Reports</span>
                        <i class="fas fa-caret-down ml-auto" [ngClass]="{'transform rotate-180': reportsDropdownOpen}"></i>
                    </a>
                    
                    <!-- Dropdown Items -->
                    <div class="pl-8 md:pl-12 overflow-hidden transition-all duration-300" [ngClass]="{'max-h-0': !reportsDropdownOpen, 'max-h-48': reportsDropdownOpen}">
                        <a class="flex  items-center py-3 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onBILOGReport()">
                            <i class="fas fa-file-alt mr-3"></i>
                            <span>Biological Indicator Report</span>
                        </a>
                        <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onUltrasonicReport()">
                            <i class="fas fa-file-alt mr-3"></i>
                            <span>Ultrasonic/Washer Report</span>
                        </a>
                        <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onWaterTestReport()">
                            <i class="fas fa-file-alt mr-3"></i>
                            <span>Waterline Test Report</span>
                        </a>
                    </div>
                </div>
                
                <a class="flex  items-center py-2 mt-3 px-4 md:px-8 text-gray-600 hover:bg-purple-50 hover:text-purple-700 hover:rounded-lg" (click)="onDeviceDetailClick()">
                    <i class="fas fa-database mr-3"></i>
                    <span>Biological Indicator Device</span>
                </a>
            </div>
        </div>
         
         <!-- Main Content -->
         <div class="flex-1 flex flex-col">
             <!-- Header -->
             <header class="flex items-center justify-between h-16 md:h-24 px-4 md:px-6 bg-white shadow-sm md:shadow-none">
                 <div class="flex items-center">
                     <h1 class="text-gray-600 text-sm font-medium">
                        Dashboard / Biological Indicator Report
                     </h1>
                 </div>
                 <div class="flex items-center">
                     <div class="relative">
                     </div>
                     <div class="flex items-center gap-2 md:gap-4">
                         <i class="fas fa-bell text-gray-400 mr-2 md:mr-4"></i>
                     
                         <div class="relative">
                             <div class="flex items-center gap-2 cursor-pointer z-20" (click)="toggleSettings($event)">
                                 <img alt="User Avatar" class="rounded-full w-8 h-8 md:w-10 md:h-10" src="assets/newui/demoprofile.png" />
                                 <span class="text-gray-600 hidden sm:inline">{{username}}</span>
                                 <i class="fas fa-caret-down ml-auto"></i>
                             </div>
                             
                             <!-- Setting popup with relative positioning and higher z-index -->
                             <div *ngIf="showSettings" class="bg-white shadow-xl rounded-lg p-3 absolute right-0 top-full mt-2 z-20 w-48 md:w-64">
                                 <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onManageAccount()">
                                     <img src="assets/newui/icons/manageAccountIcon.png" class="w-4 h-4" alt="">
                                     <p class="text-sm"> Manage Account </p>
                                 </div>
                                 <hr class="mt-2">
                                 <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onForgetPassword()">
                                     <img src="assets/newui/icons/changePasswordIcon.png" class="w-4 h-4 mt-1" alt="">
                                     <p class="text-sm"> Change Password </p>
                                 </div>
                                 <!-- <hr class="mt-2">
                                 <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer">
                                     <img src="assets/newui/icons/activityLogIcon.png" class="w-4 h-4 mt-1" alt="">
                                     <p class="text-sm"> Activity Log </p>
                                 </div> -->
                                 <hr class="mt-2">
                                 <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onLogoutClick()">
                                     <img src="assets/newui/icons/logoutIcon.png" class="w-5 h-4 mt-1" alt="">
                                     <p class="text-sm"> Logout </p>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
             </header>
             
            
            <!-- Main Section -->
            <main class="flex-1 p-3 md:p-6 overflow-auto">
                <div class="bg-gradient-to-l from-[rgba(173,0,255,0.75)] to-[rgba(173,0,255,1)] h-36 md:h-48 rounded-lg mb-4 md:mb-6">
                    <p class="font-semibold lg:text-3xl text-2xl text-white  p-10">Hello Team {{username}},</p>
                </div>
                
                <div class="bg-white p-3 md:p-6 rounded-lg shadow-xl">
                    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 space-y-3 md:space-y-0">
                        <div class="flex flex-col sm:flex-row items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-4">
                            <p>Start Date</p>
                            <input class="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg  sm:mb-0" type="date" [(ngModel)]="startTime" (change)="onDateChange()"/>
                           <p>End Date</p>
                            <input class="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg" type="date" [(ngModel)]="endTime" (change)="onDateChange()"/>
                        </div>
                        <div class="flex space-x-2 md:space-x-4">
                            <button class="flex-1 md:flex-none px-3 md:px-4 py-2 bg-red-100 text-red-600 rounded-lg text-sm md:text-base" (click)="exportPDF()">
                                PDF
                                <i class="fas fa-download text-red-500 ml-2"></i>
                            </button>
                            <button class="flex-1 md:flex-none px-3 md:px-4 py-2 bg-green-100 text-green-600 rounded-lg text-sm md:text-base" (click)="exportExcel()">
                                Excel
                                <i class="fas fa-download text-green-500 ml-2"></i>
                            </button>
                        </div>
                    </div>
                    
                    <!-- Responsive Table - Scrollable horizontally on small screens -->
                    <div class="overflow-x-auto -mx-3 md:mx-0">
                        <table class="min-w-full text-xs text-left">
                            <thead class="columnheading rounded-lg">
                                <tr>
                                    <th class="py-1 px-1 border-b border-gray-200">Record</th>
                                    <th class="py-1 px-4 border-b border-gray-200">Start Time</th>
                                    <th class="py-1 px-4 border-b border-gray-200">End Time</th> 
                                    <th class="py-2 px-1 border-b border-gray-200">Well</th>
                                    <th class="py-2 px-1 border-b border-gray-200">Serial</th>
                                    <th class="py-1 px-3 border-b border-gray-200">Result</th>
                                    <th class="py-1 px-3 border-b border-gray-200">BI Type</th>
                                    <th class="py-1 px-3 border-b border-gray-200">BI Lot Number</th>
                                    <th class="py-1 px-3 border-b border-gray-200">Sterilizer Model</th>
                                    <th class="py-1 px-3 border-b border-gray-200">Load Number</th>
                                    <th class="py-1 px-3 border-b border-gray-200">Team Member</th>
                                    <th class="py-1 px-3 border-b border-gray-200">Cycle</th>
                                    <th class="py-1 px-3 border-b border-gray-200">Chemical Integrator</th>
                                    <th class="py-1 px-3 border-b border-gray-200">Control</th>
                                    <th class="py-1 px-3 border-b border-gray-200">Implant</th>
                                </tr>
                            </thead>
                            <tbody class="bg-white">
                                <tr *ngFor="let record of filteredRecords.length > 0 ? filteredRecords : records; let i = index" class="text-center">
                                    <td class="py-2 text-sm px-1 border-b border-gray-200">{{ i+1 }}</td>
                                    <td class="py-2 px-4 border-b border-gray-200">{{ record.startTime | date:'dd-MM-yy HH:mm' }}</td>
                                    <td class="py-2 px-4 border-b border-gray-200">{{ record.endTime | date:'dd-MM-yy HH:mm:ss' }}</td> 
                                    <td class="py-2 px-1 border-b border-gray-200">{{ record.wellNumber }}</td>
                                    <td class="py-2 px-1 border-b border-gray-200">{{ record.serialNumber }}</td>
                                    <td class="py-2 px-1 border-b border-gray-200 text-red-500" [ngClass]="{
                                        'text-green-500': record.result === 'Positive', 
                                        'text-red-500': record.result === 'Negative', 
                                        'text-gray-500': record.result !== 'Positive' && record.result !== 'Negative'
                                    }">{{ record.result }}</td>
                                    <td class="py-2 px-1 border-b border-gray-200">{{ record.biType }}</td>
                                    <td class="py-2 px-1 border-b border-gray-200">{{ record.biLotNumber }} </td>
                                    <td class="py-2 px-1 border-b border-gray-200">{{ record.sterilizerModels }} </td>
                                    <td class="py-2 px-1 border-b border-gray-200">{{ record.loadNumber }} </td>
                                    <td class="py-2 px-1 border-b border-gray-200">{{ record.technicianNames }} </td>
                                    <td class="py-2 px-1 border-b border-gray-200">{{ record.cycleCount }} </td>
                                    <td class="py-2 px-1 border-b border-gray-200">{{ record.chemicalIntegrators }} </td>
                                    <td class="py-2 px-1 border-b border-gray-200">
                                        <button class="bg-blue-100 text-blue-600 controldiv px-2 md:px-4 py-1 text-xs md:text-sm"
                                        [disabled]="!record.isControlTest"
                                        [ngClass]="{
                                            'bg-blue-100 text-blue-600': record.isControlTest,
                                            'bg-gray-200 text-gray-500': !record.isControlTest
                                        }">
                                            Control
                                        </button>
                                    </td>
                                    <td class="py-2 px-1 border-b border-gray-200">
                                        <button class="text-purple-600 bg-purple-200 controldiv px-2 md:px-4 py-1 text-xs md:text-sm"
                                                [disabled]="!record.isImplant"
                                                [ngClass]="{
                                                    'bg-purple-200 text-purple-600': record.isImplant,
                                                    'bg-gray-200 text-gray-500': !record.isImplant
                                                }">
                                            Implant
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <!-- Pagination -->
                    <div class="mt-4 flex flex-col sm:flex-row items-center justify-between">
                        <span class="mb-2 sm:mb-0 text-sm md:text-base">Page {{ currentPage + 1 }} of {{ totalPages }}</span>
                        <div class="flex items-center">
                            <button class="px-3 md:px-4 py-1 md:py-2 rounded-lg mr-2 disabled:opacity-50"
                            (click)="changePage(currentPage - 1)" 
                            [disabled]="currentPage === 0">
                                &lt;
                            </button>
                            <button class="px-3 md:px-4 py-1 md:py-2 bg-gray-100 text-gray-600 rounded-lg disabled:opacity-50" 
                            (click)="changePage(currentPage + 1)" 
                            [disabled]="currentPage === totalPages || totalPages == currentPage + 1">
                                &gt;
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
    
    <app-notification-popup
        [isOpen]="showPopup"
        [message]="popupMessage"
        [type]="popupType"
        (onClose)="closePopup()">
    </app-notification-popup>
</div>